import React from "react";
import "./Frame11432.css";

function Frame11432(props) {
  const { className } = props;

  return (
    <div className={`frame-114-86 ${className || ""}`}>
      <div className="place-1 valign-text-middle inter-medium-sonic-silver-18px">Home</div>
    </div>
  );
}

export default Frame11432;
